import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import classnames from 'classnames'
import { translate } from 'react-i18next'
import { wishlisted } from '../../helpers/wishlist.helper'
import './index.sass'

class AudioSimpleControls extends Component {
  download = () => {
    const {
      voiceItem: { audioUrl, author },
    } = this.props
    fetch(audioUrl).then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = author
        a.click()
      })
    })
  }

  handleClick = () => {
    const {
      isAudioPlaying,
      setPlayingStatus,
      voiceItem,
      toggleVisibleAudioPlayer,
      setPlayingVoiceId,
    } = this.props
    if (isAudioPlaying) {
      setPlayingStatus(false)
    } else {
      toggleVisibleAudioPlayer(true)
      setPlayingStatus(true)
      setPlayingVoiceId(voiceItem.id)
    }
  }

  isWishlisted = () => {
		const { voiceItem, wishlist } = this.props
    return wishlisted(wishlist, voiceItem)
  }

  render = () => {
    const { voiceItem, isAudioPlaying, toggleFavoriteVoice, t } = this.props
    const classes = classnames({
      'btn audio-controls': true,
      'audio-controls-pause': isAudioPlaying,
      'audio-controls-play': !isAudioPlaying,
    })
    return (
      <div className="audio-player">
        <div>
          <button className={classes} onClick={this.handleClick} />
          <h6>{`${t('general.voice')} ${voiceItem.author.replace(/Voice/, '')}`}</h6>
        </div>
        <div>
          <div
            className={this.isWishlisted() ? 'icon fill' : 'icon'}
            onClick={() => toggleFavoriteVoice(voiceItem)}
          />
          <button className="btn download" onClick={this.download} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  wishlist: state.wishlist,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AudioSimpleControls)
)
